import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
export const LegalInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  minHeight: 'calc(100vh - 200px)',
  width: '100%',
  padding: theme.spacing(6),
  borderRadius: '24px',
  boxShadow: `
    0 4px 6px rgba(0, 0, 0, 0.05),
    0 10px 15px rgba(0, 0, 0, 0.03),
    0 0 0 1px rgba(0, 0, 0, 0.05)
  `,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  position: 'relative',
  overflow: 'hidden',
  boxSizing: 'border-box',
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(5),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4),
    borderRadius: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
    borderRadius: '12px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));
export const LegalInfoText = styled(Typography)(({ theme }) => ({
  '&.MuiTypography-h1': {
    fontSize: 48,
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(6),
    borderBottom: '2px solid #E2E8F0',
    paddingBottom: theme.spacing(3),
    wordBreak: 'break-word',
    [theme.breakpoints.down('md')]: {
      fontSize: 36,
      marginBottom: theme.spacing(4),
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 28,
      marginBottom: theme.spacing(3),
      paddingBottom: theme.spacing(1.5),
    },
  },
  '&.MuiTypography-h2': {
    fontSize: 32,
    fontWeight: 500,
    marginBottom: theme.spacing(1.5),
    wordBreak: 'break-word',
    [theme.breakpoints.down('md')]: {
      fontSize: 24,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  '&.MuiTypography-body2': {
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 500,
    marginBottom: theme.spacing(6),
    wordBreak: 'break-word',
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
      marginBottom: theme.spacing(3),
    },
  },
  '&.MuiTypography-body1': {
    fontSize: 16,
    lineHeight: 1.9,
    color: '#2D3748',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      lineHeight: 1.8,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
      lineHeight: 1.7,
    },
  },
}));
export const SectionPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginBottom: theme.spacing(4),
  background: 'transparent',
  backdropFilter: 'blur(10px)',
  borderRadius: '16px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
  border: '1px solid rgba(66, 153, 225, 0.1)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
    borderRadius: '12px',
    marginBottom: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
    borderRadius: '8px',
    marginBottom: theme.spacing(2),
  },
}));
